import { render } from "./OverflowView.vue?vue&type=template&id=58907fa0&scoped=true"
import script from "./OverflowView.vue?vue&type=script&lang=js"
export * from "./OverflowView.vue?vue&type=script&lang=js"

import "./OverflowView.vue?vue&type=style&index=0&id=58907fa0&scoped=true&lang=css"

import exportComponent from "/home/www/.jenkins/workspace/131-front-vue-8081/code/node_modules/vue-loader/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render],['__scopeId',"data-v-58907fa0"]])

export default __exports__